import { useRef, useState } from "react";
import {
  BottomText,
  BottomTitles,
  Container,
  CurrentStatus,
  GreyBar,
  IterableBottom,
  IterableSubTitle,
  IterableTitle,
  IterableTitleSlot,
  PBContainer,
  IterableData,
  Warning,
  LastData,
  ImageHolder,
  ImageDiv,
  PlaceHolderCounter,
} from "./styles";
import Flash from "../../../assets/icons/Flash";
import TaskPopper from "./TasksPopper/index";
import Button from "../../../components/general/Button";
import Trash from "../../../assets/icons/Trash";
import ExcludeModal from "./ExcludeModal";
import ProgressBar from "./ProgressBar";
import WorkersPopper from "./WorkersPopper";
import { DateTime } from "luxon";
import { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { handleRemoveActivedFlow } from "../../../state/activedFlows/actions";
import { toastAlert } from "../../../components/Toastify";
import { ProtectedComponent } from "../../../components/general/Protected";

const ActiveIterable = ({
  onClick = null,
  jobs,
  title, //string
  description, //string
  startDate, //string date (data de criação)doneLateTasks
  flowId,
  client, //string
  reload,
  relatedUsers,
  flowProgress,
  //? Modifications are being made
  estimatedAt,
  criticalDate,
}) => {
  const [popperOpen, setPopperOpen] = useState(false);
  const [wPopperOpen, setWPopperOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const divRef = useRef(null);

  const momentTasks = jobs?.filter(
    (item) => item.status === "doing" || item.status === "late",
  );

  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const startedAt = DateTime.fromISO(startDate);
  const prevision = estimatedAt ? DateTime.fromISO(estimatedAt) : null;

  function calculateDelta(estimatedAt, criticalDate) {
    let mensagem = "- -"; // Fallback message for display
    let flowDelta = 0; // Default flow delta value

    // Parse the dates using Luxon for consistent handling
    const { DateTime } = require("luxon"); // Assuming Luxon is required at the top of your file
    const estimatedDate = estimatedAt ? DateTime.fromISO(estimatedAt) : null;
    const criticalDateTime = criticalDate
      ? DateTime.fromISO(criticalDate)
      : null;

    if (
      estimatedDate &&
      criticalDateTime &&
      estimatedDate.isValid &&
      criticalDateTime.isValid
    ) {
      const diff = estimatedDate.diff(criticalDateTime, ["hours"]).toObject();
      flowDelta = diff.hours; // Assign the hours difference to flowDelta
      const hoursDelta = Math.abs(diff.hours);
      const daysDelta = hoursDelta / 24;

      // Construct the delay message based on the duration of the delay
      if (hoursDelta < 24) {
        mensagem = `${hoursDelta.toFixed(2)} horas`;
      } else {
        mensagem = `${daysDelta.toFixed(2)} dias`;
      }
      if (diff.hours > 2) {
        // Atrasado
        mensagem = `O Fluxo está atrasado por aproximadamente ${mensagem}.`;
      } else if (diff.hours < -2) {
        // Changed from diff.hours < 2 for clarity on being ahead of schedule
        // Adiantado
        mensagem = `O Fluxo está adiantado por aproximadamente ${mensagem}.`;
      } else {
        // No tempo previsto
        mensagem = "O Fluxo está no tempo previsto.";
      }
    }

    return { mensagem, flowDelta }; // Return the message and flowDelta
  }

  const { mensagem, flowDelta } = calculateDelta(estimatedAt, criticalDate);

  const debouncedHandleMouseEnter = debounce(() => setPopperOpen(true), 500);
  const delayWPopper = debounce(() => setWPopperOpen(true), 500);

  //object literalls ?
  const status =
    flowDelta > 2
      ? "Atrasado"
      : flowDelta >= -2 && flowDelta <= 2
        ? "Em risco"
        : "Em dia";

  const handleOnMouseLeave = () => {
    setPopperOpen(false);
    debouncedHandleMouseEnter.cancel();
  };

  const handleOnMouseLeaveW = () => {
    setWPopperOpen(false);
    delayWPopper.cancel();
  };

  const handleRemove = async () => {
    dispatch(handleRemoveActivedFlow({ flowId }))
      .then((res) => {
        setConfirmOpen(false);
        reload();
        toastAlert({ msg: "Fluxo Ativo deletado com sucesso" });
      })
      .catch(() =>
        toastAlert({
          msg: "Ocorreu um erro ao deletar o fluxo ativo",
          isError: true,
        }),
      );
  };

  return (
    <>
      <Container onClick={onClick}>
        <IterableTitleSlot>
          <IterableTitle>{title}</IterableTitle>
          <CurrentStatus status={status}>{status}</CurrentStatus>
          <Warning delta={flowDelta}>{mensagem}</Warning>
        </IterableTitleSlot>
        <IterableSubTitle>{description}</IterableSubTitle>
        <GreyBar />
        <IterableBottom>
          <IterableData width={"12%"}>
            <BottomTitles>Data de Início</BottomTitles>
            <BottomText>{startedAt.toFormat("dd/MM/yyyy")}</BottomText>
          </IterableData>
          <IterableData width={"15%"}>
            <BottomTitles>Data de Prazo Final</BottomTitles>
            <BottomText>{prevision?.toFormat("dd/MM/yyyy")}</BottomText>
          </IterableData>
          <IterableData width={"15.6%"}>
            <BottomTitles>Cliente</BottomTitles>
            <BottomText>{client}</BottomText>
          </IterableData>
          <IterableData
            width={"20.5%"}
            onMouseEnter={debouncedHandleMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          >
            <BottomTitles>Tarefas em andamento</BottomTitles>
            <BottomText>
              {momentTasks.length > 0 ? (
                <>
                  <Flash />
                  <div>
                    {momentTasks[0]?.label}
                    <span>
                      {momentTasks.length > 1
                        ? `(+${momentTasks.length - 1})`
                        : null}
                    </span>
                  </div>
                </>
              ) : (
                "-"
              )}
            </BottomText>
            <TaskPopper
              isOpen={momentTasks.length > 1 && popperOpen}
              onClose={() => setPopperOpen(false)}
              onConfirm={(e) => {
                console.log(e);
              }}
              anchorRef={divRef}
              currentTasks={momentTasks}
            />
          </IterableData>
          <IterableData width={"20.9%"}>
            <BottomTitles>Progresso</BottomTitles>

            <PBContainer>
              <ProgressBar progress={flowProgress * 100} status={status} />
            </PBContainer>
          </IterableData>
          <LastData width={"17%"}>
            <ImageDiv
              onMouseLeave={handleOnMouseLeaveW}
              onMouseEnter={delayWPopper}
            >
              {relatedUsers.length > 0 && relatedUsers.length < 5
                ? relatedUsers.map((item, index) => (
                    <ImageHolder
                      key={Math.random() + index}
                      src={item.avatarURL}
                    />
                  ))
                : relatedUsers.length >= 5
                  ? relatedUsers
                      .slice(0, 5)
                      .map((item, index) => (
                        <ImageHolder
                          key={Math.random() + index}
                          src={item.avatarURL}
                        />
                      ))
                  : null}
              {relatedUsers.length > 5 ? (
                <PlaceHolderCounter>
                  {"+" + (relatedUsers.length - 5)}
                </PlaceHolderCounter>
              ) : null}
              {relatedUsers.length > 0 ? (
                <WorkersPopper
                  isOpen={wPopperOpen}
                  onClose={() => setWPopperOpen(false)}
                  onConfirm={(e) => {
                    console.log(e);
                  }}
                  Workers={relatedUsers}
                />
              ) : null}
            </ImageDiv>
          </LastData>
        </IterableBottom>
        <ProtectedComponent allowed={["admin", "gerente"]} rank={user?.rank}>
          <Button
            Icon={() => <Trash />}
            onClick={(event) => {
              event.stopPropagation();
              setConfirmOpen(true);
            }}
            square
            style={{
              position: "absolute",
              right: "1rem",
              top: "1rem",
              zIndex: 0,
            }}
            size="2.15rem"
            background="#FFBAAB"
            colorText="#D93333"
            activeBackground="#CB9A8F"
          />
        </ProtectedComponent>
      </Container>
      <ExcludeModal
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        flowName={title}
        onConfirm={handleRemove}
        tipe="Ativo"
      />
    </>
  );
};

export default ActiveIterable;
